import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=e9d2ad68&scoped=true&"
import script from "./infos.vue?vue&type=script&lang=js&"
export * from "./infos.vue?vue&type=script&lang=js&"
import style0 from "./infos.vue?vue&type=style&index=0&id=e9d2ad68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d2ad68",
  null
  
)

export default component.exports